import React from 'react';
import { Form, Button, Icon, Message } from 'semantic-ui-react'
import _find from 'lodash/find';

const ListaTL = ({handleLista}) => {
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="miLista5" id="miLista5" onChange={handleLista}>
        <option>Seleccionar...</option>
        <option>Aceite</option>
        <option>Grasa</option>
        <option>Otro</option>
      </select>
    </div>
  )
};

const ListaCL = ({handleLista}) => {
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="miLista2" id="miLista2" onChange={handleLista}>
        <option>Seleccionar...</option>
        <option>Mineral</option>
        <option>Sintético</option>
        <option>Vegetal</option>
      </select>
    </div>
  )
};

const ListaCA = ({handleLista}) => {
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="miLista3" id="miLista3" onChange={handleLista}>
        <option>Seleccionar...</option>
        <option>H1</option>
        <option>H2</option>
        <option>H3</option>
        <option>3H</option>
      </select>
    </div>
  )
};

const ListaTG = ({handleLista}) => {
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="miLista1" id="miLista1" onChange={handleLista}>
        <option>Seleccionar...</option>
        <option>ISO</option>
        <option>SAE</option>
        <option>NLGI</option>
      </select>
    </div>
  )
};

const ListaAM = ({handleLista}) => {
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="miLista6" id="miLista6" onChange={handleLista}>
        <option>Seleccionar...</option>
        <option>EP</option>
        <option>AW</option>
      </select>
    </div>
  )
};

const ListaSN = ({nameLista, handleLista}) => {
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name={nameLista} id={nameLista} onChange={(ev)=>handleLista(ev, nameLista)}>
        <option>Seleccionar...</option>
        <option>Si</option>
        <option>No</option>
      </select>
    </div>
  )
};

const ListaSAL = ({handleLista}) => {
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="miLista13" id="miLista13" onChange={handleLista}>
        <option>Seleccionar...</option>
        <option>0 Sin riesgo</option>
        <option>1 Poco peligroso</option>
        <option>2 Peligroso</option>
        <option>3 Muy peligroso</option>
        <option>4 Mortal</option>
      </select>
    </div>
  )
};

const ListaINF = ({handleLista}) => {
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="miLista14" id="miLista14" onChange={handleLista}>
        <option>Seleccionar...</option>
        <option>0 No se inflama</option>
        <option>1 Sobre 93 °C</option>
        <option>2 Debajo de 93 °C</option>
        <option>3 Debajo de 37 °C</option>
        <option>4 Debajo de 25 °C</option>
      </select>
    </div>
  )
};

const ListaREA = ({handleLista}) => {
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="miLista15" id="miLista15" onChange={handleLista}>
        <option>Seleccionar...</option>
        <option>0 Estable</option>
        <option>1 Inestable en caso de calentamiento</option>
        <option>2 Inestable en caso de cambio quimico violento</option>
        <option>3 Puede explotar en caso de choque o calentamiento</option>
        <option>4 Puede explotar subitamente</option>
      </select>
    </div>
  )
};

const ListaBLA = ({handleLista}) => {
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="miLista16" id="miLista16" onChange={handleLista}>
        <option>Seleccionar...</option>
        <option>BIO Riesgo biológico</option>
        <option>CORR Corrosivo</option>
        <option>CRYO Criogénico</option>
        <option>OXY Oxidante</option>
        <option>POI Producto venenoso</option>
        <option>RAD radioactivo</option>
        <option>SA Gas asfixiante simple</option>
        <option>W Reacciona con agua</option>      
      </select>
    </div>
  )
};

const DetalleNivel1 = props => {
  let apiSAE=""
  if(props.elemento.apiSAE){
    apiSAE = " - " + props.elemento.apiSAE
  }
  return (
    <option dato1={props.elemento.descrGrado} dato2={props.elemento.apiSAE} dato3={props.elemento.color} value={props.elemento._id}>{props.elemento.descrGrado}{apiSAE}</option>
  )
};

const ListaGR = ({handleLista, list}) => {
  const Nivel1Detalle = list.map((elemento, _id) => <DetalleNivel1 elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="descrGrado" id="miLista4" onChange={handleLista}>
        <option value="">Seleccionar...</option>
        {Nivel1Detalle}
      </select>
    </div>
  )
};

const DetalleNivel2 = props => {
  return (
    <option dato1={props.elemento.color} dato2={props.elemento.colorTexto}  value={props.elemento._id}>{props.elemento.descrGrado}</option>
  )
};
const ListaIsoGR = ({handleLista, list}) => {
  const Nivel2Detalle = list.map((elemento, _id) => <DetalleNivel2 elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="isoGrado" id="miLista44" onChange={handleLista}>
        <option value="">Seleccionar...</option>
        {Nivel2Detalle}
      </select>
    </div>
  )
};

const AddLubricante2 = ({styles, list, list1, handleLista, handleLista1, handleLista2, 
  handleLista3, handleLista4, handleLista44, handleLista6, handleLista7, handleLista8, 
  handleLista9, handleLista10, handleLista11, handleLista12, 
  handleSubmit, handleChange, args, errors}) => {
//class AddLubricante2  extends React.Component {
  let listGr=[]
  if (args.tipoGrado){
    let tipoGr=args.tipoGrado
    listGr = list1.filter(elemento => elemento.tipoGrado===tipoGr)
  }  
  let listIsoGR=[]
  listIsoGR = list1.filter(elemento => elemento.tipoGrado==='ISO')
  

  // let listU=[]
  // if (args.tipoLub){
  //   let tipoL=args.tipoLub
  //   listU = list2.filter(elemento => elemento.tipoUnidad===tipoL)
  // }

return(
    <div>
      <button className="ui right labeled icon button" style={styles.titBuscar}>
        <i className="large plus yellow icon"></i>
        Lubricante nuevo
      </button>
      <div style={styles.box}>
        <Form onSubmit={(ev)=>handleSubmit(ev, args)}>
          <div className="ui four column stackable grid">
            <div className="row container">
              <div className="column" width="25%">
                <Form.Field>
                  <label style={styles.label}>Descripción</label>
                  <Form.Input autoComplete="off" name="descrLubricante" id="descrLubricante" onChange={handleChange} placeholder='Descripción' icon={!errors.length?null: _find(errors, {path:'descrLubricante'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                </Form.Field>
                <Form.Field>
                  <label style={styles.label}>Marca</label>
                  <Form.Input autoComplete="off" name="descrFabricante" id="descrFabricante" onChange={handleChange} placeholder='Marca' icon={!errors.length?null: _find(errors, {path:'descrFabricante'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                </Form.Field>
                <Form.Field>
                  <label style={styles.label}>Tipo de lubricante</label>
                  <ListaTL handleLista={handleLista} />
                </Form.Field>
                <Form.Field>
                  <label style={styles.label}>Clase de lubricante</label>
                  <ListaCL handleLista={handleLista2} />
                </Form.Field>
                <Form.Field>
                  <label style={styles.label}>Categoría</label>
                  <ListaCA handleLista={handleLista3} />
                </Form.Field>
                <Form.Field>
                  <label style={styles.label}>Tipo de grado</label>
                  <ListaTG handleLista={handleLista1} />
                </Form.Field>
                <Form.Field>
                  <label style={styles.label}>Grado</label>
                  <ListaGR list={listGr} handleLista={handleLista4} />
                </Form.Field>
                {args.tipoLub==='Grasa' &&
                  <Form.Field>
                    <label style={styles.label}>ISO</label>
                    <ListaIsoGR list={listIsoGR} handleLista={handleLista44} />
                  </Form.Field>
                }
                {/* <Form.Field>
                  <label style={styles.label}>Unidad</label>
                  <ListaUN list={listU} handleLista={handleLista8} />
                </Form.Field>                 */}
                {args.tipoLub==='Aceite' &&
                <div>                
                  <Form.Field>
                    <label style={styles.label}>Color</label>
                    <input type='number' step="0.00001" min="0" autoComplete="off" name="color" id="color" placeholder='Color' onChange={handleChange}/>
                  </Form.Field>                    
                  <Form.Field>
                    <label style={styles.label}>Viscosidad, cSt a 40ºC</label>
                    <input type='number' step="0.00001" min="0" autoComplete="off" name="visco40" id="visco40" placeholder='Viscosidad, cSt a 40ºC' onChange={handleChange}/>
                  </Form.Field>
                  <Form.Field>
                    <label style={styles.label}>Viscosidad, cSt a 100ºC</label>
                    <input type='number' step="0.00001" min="0" autoComplete="off" name="visco100" id="visco100" placeholder='Viscosidad, cSt a 100ºC' onChange={handleChange}/>
                  </Form.Field>
                  <Form.Field>
                    <label style={styles.label}>Indice de Viscosidad IV</label>
                    <input type='number' step="0.00001" min="0" autoComplete="off" name="indice" id="indice" placeholder='Indice de Viscosidad IV' onChange={handleChange}/>
                  </Form.Field>                    
                  <Form.Field>
                    <label style={styles.label}>Agua</label>
                    <input type='number' step="0.00001" min="0" autoComplete="off" name="agua" id="agua" placeholder='Agua' onChange={handleChange}/>
                  </Form.Field>
                  <Form.Field>
                    <label style={styles.label}>Código de particulas (00/00/00)</label>
                    <Form.Input autoComplete="off" name="codigoPar" id="codigoPar" onChange={handleChange} placeholder='Código de particulas (00/00/00)' icon={!errors.length?null: _find(errors, {path:'codigoPar'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                  </Form.Field>                  
                  <Form.Field>
                    <label style={styles.label}>Particulas {">"} 4 micras</label>
                    <input type='number' step="0.00001" min="0" autoComplete="off" name="micras4" id="micras4" placeholder='Particulas > 4 micras' onChange={handleChange}/>
                  </Form.Field>                    
                  <Form.Field>
                    <label style={styles.label}>Particulas {">"} 6 micras</label>
                    <input type='number' step="0.00001" min="0" autoComplete="off" name="micras6" id="micras6" placeholder='Particulas > 6 micras' onChange={handleChange}/>
                  </Form.Field> 
                  <Form.Field>
                    <label style={styles.label}>Particulas {">"} 14 micras</label>
                    <input type='number' step="0.00001" min="0" autoComplete="off" name="micras14" id="micras14" placeholder='Particulas > 14 micras' onChange={handleChange}/>
                  </Form.Field> 
                  <Form.Field>
                    <label style={styles.label}>Particulas {">"} 21 micras</label>
                    <input type='number' step="0.00001" min="0" autoComplete="off" name="micras21" id="micras21" placeholder='Particulas > 21 micras' onChange={handleChange}/>
                  </Form.Field>                    
                  <Form.Field>
                    <label style={styles.label}>Particulas {">"} 25 micras</label>
                    <input type='number' step="0.00001" min="0" autoComplete="off" name="micras25" id="micras25" placeholder='Particulas > 25 micras' onChange={handleChange}/>
                  </Form.Field> 
                  <Form.Field>
                    <label style={styles.label}>Particulas {">"} 38 micras</label>
                    <input type='number' step="0.00001" min="0" autoComplete="off" name="micras38" id="micras38" placeholder='Particulas > 38 micras' onChange={handleChange}/>
                  </Form.Field> 
                  <Form.Field>
                    <label style={styles.label}>Particulas {">"} 70 micras</label>
                    <input type='number' step="0.00001" min="0" autoComplete="off" name="micras70" id="micras70" placeholder='Particulas > 70 micras' onChange={handleChange}/>
                  </Form.Field> 
                  <Form.Field>
                    <label style={styles.label}>Hollín</label>
                    <input type='number' step="0.00001" min="0" autoComplete="off" name="hollin" id="hollin" placeholder='Hollín' onChange={handleChange}/>
                  </Form.Field>
                </div>  
                }
              </div>  
              <div className="column" width="25%">    
                {args.tipoLub==='Aceite' &&
                  <div>   
                    <Form.Field>
                      <label style={styles.label}>Nitración</label>
                      <input type='number' step="0.00001" min="0" autoComplete="off" name="nitracion" id="nitracion" placeholder='Nitración' onChange={handleChange}/>
                    </Form.Field>
                    <Form.Field>
                      <label style={styles.label}>Sulfatación</label>
                      <input type='number' step="0.00001" min="0" autoComplete="off" name="sulfatacion" id="sulfatacion" placeholder='Sulfatación' onChange={handleChange}/>
                    </Form.Field>                    
                    <Form.Field>
                      <label style={styles.label}>Dilución por Combustible</label>
                      <input type='number' step="0.00001" min="0" autoComplete="off" name="dilucion" id="dilucion" placeholder='Dilución por Combustible' onChange={handleChange}/>
                    </Form.Field>
                    <Form.Field>
                      <label style={styles.label}>Glicol</label>
                      <input type='number' step="0.00001" min="0" autoComplete="off" name="glicol" id="glicol" placeholder='Glicol' onChange={handleChange}/>
                    </Form.Field>
                    <Form.Field>
                      <label style={styles.label}>Oxidación</label>
                      <input type='number' step="0.00001" min="0" autoComplete="off" name="oxidacion" id="oxidacion" placeholder='Oxidación' onChange={handleChange}/>
                    </Form.Field>                    
                    <Form.Field>
                      <label style={styles.label}>TAN</label>
                      <input type='number' step="0.00001" min="0" autoComplete="off" name="tan" id="tan" placeholder='TAN' onChange={handleChange}/>
                    </Form.Field>
                    <Form.Field>
                      <label style={styles.label}>TBN</label>
                      <input type='number' step="0.00001" min="0" autoComplete="off" name="tbn" id="tbn" placeholder='TBN' onChange={handleChange}/>
                    </Form.Field>
                    <Form.Field>
                      <label style={styles.label}>Hierro</label>
                      <input type='number' step="0.00001" min="0" autoComplete="off" name="hierro" id="hierro" placeholder='Hierro' onChange={handleChange}/>
                    </Form.Field>                    
                    <Form.Field>
                      <label style={styles.label}>Cobre</label>
                      <input type='number' step="0.00001" min="0" autoComplete="off" name="cobre" id="cobre" placeholder='Cobre' onChange={handleChange}/>
                    </Form.Field>
                    <Form.Field>
                      <label style={styles.label}>Aluminio</label>
                      <input type='number' step="0.00001" min="0" autoComplete="off" name="aluminio" id="aluminio" placeholder='Aluminio' onChange={handleChange}/>
                    </Form.Field>
                    <Form.Field>
                      <label style={styles.label}>Cromo</label>
                      <input type='number' step="0.00001" min="0" autoComplete="off" name="cromo" id="cromo" placeholder='Cromo' onChange={handleChange}/>
                    </Form.Field>                    
                    <Form.Field>
                      <label style={styles.label}>Plomo</label>
                      <input type='number' step="0.00001" min="0" autoComplete="off" name="plomo" id="plomo" placeholder='Plomo' onChange={handleChange}/>
                    </Form.Field>
                    <Form.Field>
                      <label style={styles.label}>Estaño</label>
                      <input type='number' step="0.00001" min="0" autoComplete="off" name="estano" id="estano" placeholder='Estaño' onChange={handleChange}/>
                    </Form.Field>
                    <Form.Field>
                      <label style={styles.label}>Niquel</label>
                      <input type='number' step="0.00001" min="0" autoComplete="off" name="niquel" id="niquel" placeholder='Niquel' onChange={handleChange}/>
                    </Form.Field>                    
                    <Form.Field>
                      <label style={styles.label}>Vanadio</label>
                      <input type='number' step="0.00001" min="0" autoComplete="off" name="vanadio" id="vanadio" placeholder='Vanadio' onChange={handleChange}/>
                    </Form.Field>
                    <Form.Field>
                      <label style={styles.label}>Titanio</label>
                      <input type='number' step="0.00001" min="0" autoComplete="off" name="titanio" id="titanio" placeholder='Titanio' onChange={handleChange}/>
                    </Form.Field>
                    <Form.Field>
                      <label style={styles.label}>Silicio</label>
                      <input type='number' step="0.00001" min="0" autoComplete="off" name="silicio" id="silicio" placeholder='Silicio' onChange={handleChange}/>
                    </Form.Field>                    
                    <Form.Field>
                      <label style={styles.label}>Sodio</label>
                      <input type='number' step="0.00001" min="0" autoComplete="off" name="sodio" id="sodio" placeholder='Sodio' onChange={handleChange}/>
                    </Form.Field>
                    <Form.Field>
                      <label style={styles.label}>Potasio</label>
                      <input type='number' step="0.00001" min="0" autoComplete="off" name="potasio" id="potasio" placeholder='Potasio' onChange={handleChange}/>
                    </Form.Field>
                    <Form.Field>
                      <label style={styles.label}>Boro</label>
                      <input type='number' step="0.00001" min="0" autoComplete="off" name="boro" id="boro" placeholder='Boro' onChange={handleChange}/>
                    </Form.Field>                    
                    <Form.Field>
                      <label style={styles.label}>Magnesio</label>
                      <input type='number' step="0.00001" min="0" autoComplete="off" name="magnesio" id="magnesio" placeholder='Magnesio' onChange={handleChange}/>
                    </Form.Field>
                    <Form.Field>
                      <label style={styles.label}>Calcio</label>
                      <input type='number' step="0.00001" min="0" autoComplete="off" name="calcio" id="calcio" placeholder='Calcio' onChange={handleChange}/>
                    </Form.Field>                                        
                    <Form.Field>
                      <label style={styles.label}>Fosforo</label>
                      <input type='number' step="0.00001" min="0" autoComplete="off" name="fosforo" id="fosforo" placeholder='Fosforo' onChange={handleChange}/>
                    </Form.Field>
                  </div>  
                }
              </div>  
              <div className="column" width="25%">    
                {args.tipoLub==='Aceite' &&
                  <div>                       
                    <Form.Field>
                      <label style={styles.label}>Zinc</label>
                      <input type='number' step="0.00001" min="0" autoComplete="off" name="zinc" id="zinc" placeholder='Zinc' onChange={handleChange}/>
                    </Form.Field>                    
                    <Form.Field>
                      <label style={styles.label}>Molibdeno</label>
                      <input type='number' step="0.00001" min="0" autoComplete="off" name="molibdeno" id="molibdeno" placeholder='Molibdeno' onChange={handleChange}/>
                    </Form.Field>
                    <Form.Field>
                      <label style={styles.label}>Bario</label>
                      <input type='number' step="0.00001" min="0" autoComplete="off" name="bario" id="bario" placeholder='Bario' onChange={handleChange}/>
                    </Form.Field>
                    <Form.Field>
                      <label style={styles.label}>Manganeso</label>
                      <input type='number' step="0.00001" min="0" autoComplete="off" name="manganeso" id="manganeso" placeholder='Manganeso' onChange={handleChange}/>
                    </Form.Field>                    
                    <Form.Field>
                      <label style={styles.label}>Punto de fluidez</label>
                      <input type='number' step="0.00001" min="-9999" autoComplete="off" name="fluidez" id="fluidez" placeholder='Punto de fluidez' onChange={handleChange}/>
                    </Form.Field>
                    <Form.Field>
                      <label style={styles.label}>Punto de inflamación</label>
                      <input type='number' step="0.00001" min="0" autoComplete="off" name="inflamacion" id="inflamacion" placeholder='Punto de inflamación' onChange={handleChange}/>
                    </Form.Field>
                    <Form.Field>
                      <label style={styles.label}>Cenizas sulfatadas</label>
                      <input type='number' step="0.00001" min="0" autoComplete="off" name="cenizas" id="cenizas" placeholder='Cenizas sulfatadas' onChange={handleChange}/>
                    </Form.Field>                    
                    <Form.Field>
                      <label style={styles.label}>TOST</label>
                      <input type='number' step="0.00001" min="0" autoComplete="off" name="tost" id="tost" placeholder='TOST' onChange={handleChange}/>
                    </Form.Field>
                    <Form.Field>
                      <label style={styles.label}>RPVOT</label>
                      <input type='number' step="0.00001" min="0" autoComplete="off" name="rpvot" id="rpvot" placeholder='RPVOT' onChange={handleChange}/>
                    </Form.Field>
                    <Form.Field>
                      <label style={styles.label}>Aditivos metálicos AW/EP</label>
                      <ListaAM handleLista={handleLista6} />
                    </Form.Field>
                    <Form.Field>
                      <label style={styles.label}>Phosphorus</label>
                      <input type='number' step="0.00001" min="0" autoComplete="off" name="phosporus" id="phosporus" placeholder='Phosphorus' onChange={handleChange}/>
                    </Form.Field>
                    <Form.Field>
                      <label style={styles.label}>Factor de Velocidad de la Grasa</label>
                      <input type='number' step="0.00001" min="0" autoComplete="off" name="grasa" id="grasa" placeholder='Factor de Velocidad de la Grasa' onChange={handleChange}/>
                    </Form.Field>
                    <Form.Field>
                      <label style={styles.label}>Separabilidad de agua</label>
                      <input type='number' step="0.00001" min="0" autoComplete="off" name="separabilidad" id="separabilidad" placeholder='Separabilidad de agua' onChange={handleChange}/>
                    </Form.Field>
                    <Form.Field>
                      <label style={styles.label}>Ensayo de abrasión de engranajes FZG</label>
                      <input type='number' step="0.00001" min="0" autoComplete="off" name="abrasion" id="abrasion" placeholder='Ensayo de abrasión de engranajes FZG' onChange={handleChange}/>
                    </Form.Field>
                    <Form.Field>
                      <label style={styles.label}>Cuatro Bolas EP</label>
                      <input type='number' step="0.00001" min="0" autoComplete="off" name="bolas" id="bolas" placeholder='Cuatro Bolas EP' onChange={handleChange}/>
                    </Form.Field>
                    <Form.Field>
                      <label style={styles.label}>Cuatro bolas huella de desgaste</label>
                      <input type='number' step="0.00001" min="0" autoComplete="off" name="huella" id="huella" placeholder='Cuatro bolas huella de desgaste' onChange={handleChange}/>
                    </Form.Field>
                    <Form.Field>
                      <label style={styles.label}>Carga Timken</label>
                      <input type='number' step="0.00001" min="0" autoComplete="off" name="timken" id="timken" placeholder='Carga Timken' onChange={handleChange}/>
                    </Form.Field>
                    <Form.Field>
                      <label style={styles.label}>Tendencia/Estabilidad a la formación de espuma</label>
                      {/* <input type='number' step="0.00001" min="0" autoComplete="off" name="espuma" id="espuma" placeholder='Tendencia/Estabilidad a la formación de espuma' onChange={handleChange}/> */}
                      <Form.Input autoComplete="off" name="espuma" id="espuma" onChange={handleChange} placeholder='Tendencia/Estabilidad a la formación de espuma' icon={!errors.length?null: _find(errors, {path:'espuma'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                    </Form.Field>
                    <Form.Field>
                      <label style={styles.label}>Secuencia I</label>
                      <input type='number' step="0.00001" min="0" autoComplete="off" name="secuencia1" id="secuencia1" placeholder='Secuencia I' onChange={handleChange}/>
                    </Form.Field>
                    <Form.Field>
                      <label style={styles.label}>Secuencia II</label>
                      <input type='number' step="0.00001" min="0" autoComplete="off" name="secuencia2" id="secuencia2" placeholder='Secuencia II' onChange={handleChange}/>
                    </Form.Field>
                    <Form.Field>
                      <label style={styles.label}>Secuencia III</label>
                      <input type='number' step="0.00001" min="0" autoComplete="off" name="secuencia3" id="secuencia3" placeholder='Secuencia III' onChange={handleChange}/>
                    </Form.Field>
                    <Form.Field>
                      <label style={styles.label}>Liberación de aire (Aeroemulsión)</label>
                      <input type='number' step="0.00001" min="0" autoComplete="off" name="aeroemulsion" id="aeroemulsion" placeholder='Liberación de aire (Aeroemulsión)' onChange={handleChange}/>
                    </Form.Field>
                    <Form.Field>
                      <label style={styles.label}>Demulsibilidad</label>
                      <input type='number' step="0.00001" min="0" autoComplete="off" name="demulsibilidad" id="demulsibilidad" placeholder='Demulsibilidad' onChange={handleChange}/>
                    </Form.Field>
                  </div>  
                }
              </div>  
              <div className="column" width="25%">    
                {args.tipoLub==='Aceite' &&
                  <div>                      
                     <Form.Field>
                      <label style={styles.label}>Aceite-Agua-Emulsión</label>
                      <input type='number' step="0.00001" min="0" autoComplete="off" name="emulsion" id="emulsion" placeholder='Aceite-Agua-Emulsión' onChange={handleChange}/>
                    </Form.Field>
                    <Form.Field>
                      <label style={styles.label}>Corrosión de tira de cobre</label>
                      <Form.Input autoComplete="off" name="corrosion" id="corrosion" onChange={handleChange} placeholder='Corrosión de tira de cobre' icon={!errors.length?null: _find(errors, {path:'corrosion'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                    </Form.Field>
                    <Form.Field>
                      <label style={styles.label}>Prevención de la herrumbre</label>
                      <Form.Input autoComplete="off" name="herrumbre" id="herrumbre" onChange={handleChange} placeholder='Prevención de la herrumbre' icon={!errors.length?null: _find(errors, {path:'herrumbre'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                    </Form.Field>
                    <Form.Field>
                      <label style={styles.label}>Agua destilada</label>
                      <Form.Input autoComplete="off" name="destilada" id="destilada" onChange={handleChange} placeholder='Agua destilada' icon={!errors.length?null: _find(errors, {path:'destilada'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                    </Form.Field>
                    <Form.Field>
                      <label style={styles.label}>Agua de mar</label>
                      <Form.Input autoComplete="off" name="deMar" id="deMar" onChange={handleChange} placeholder='Agua de mar' icon={!errors.length?null: _find(errors, {path:'deMar'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                    </Form.Field>
                    <Form.Field>
                      <label style={styles.label}>Temperatura Máximo de Uso</label>
                      <input type='number' step="0.00001" min="0" autoComplete="off" name="temperatura" id="temperatura" placeholder='Temperatura Máximo de Uso' onChange={handleChange}/>
                    </Form.Field>
                    <Form.Field>
                      <label style={styles.label}>Penetración trabajada</label>
                      <input type='number' step="0.00001" min="0" autoComplete="off" name="penetracion" id="penetracion" placeholder='Penetración trabajada' onChange={handleChange}/>
                    </Form.Field>
                    <Form.Field>
                      <label style={styles.label}>Punto de goteo</label>
                      <input type='number' step="0.00001" min="0" autoComplete="off" name="goteo" id="goteo" placeholder='Punto de goteo' onChange={handleChange}/>
                    </Form.Field>
                    <Form.Field>
                      <label style={styles.label}>Lavado Agua</label>
                      <input type='number' step="0.00001" min="0" autoComplete="off" name="lavado" id="lavado" placeholder='Lavado Agua' onChange={handleChange}/>
                    </Form.Field>
                    <Form.Field>
                      <label style={styles.label}>NSF ISO 21469:2006</label>
                      <ListaSN nameLista='miLista7' handleLista={handleLista7}/>
                    </Form.Field>
                    <Form.Field>
                      <label style={styles.label}>FDA</label>
                      <ListaSN nameLista='miLista8' handleLista={handleLista7}/>
                    </Form.Field>
                    <Form.Field>
                      <label style={styles.label}>Biodegradables OECD 301 B</label>
                      <ListaSN nameLista='miLista9' handleLista={handleLista7}/>
                    </Form.Field>
                    <Form.Field>
                      <label style={styles.label}>No toxico EPA560/6-82-002</label>
                      <ListaSN nameLista='miLista10' handleLista={handleLista7}/>
                    </Form.Field>
                    <Form.Field>
                      <label style={styles.label}>Ignifugo</label>
                      <ListaSN nameLista='miLista11' handleLista={handleLista7}/>
                    </Form.Field>
                    <Form.Field>
                      <label style={styles.label}>Cumple con la norma FM 6930</label>
                      <ListaSN nameLista='miLista12' handleLista={handleLista7}/>
                    </Form.Field>
                    <Form.Field>
                      <label style={styles.label}>Salud</label>
                      <ListaSAL handleLista={handleLista9} />
                    </Form.Field>
                    <Form.Field>
                      <label style={styles.label}>Inflamabilidad</label>
                      <ListaINF handleLista={handleLista10} />
                    </Form.Field>
                    <Form.Field>
                      <label style={styles.label}>Reactividad</label>
                      <ListaREA handleLista={handleLista11} />
                    </Form.Field>
                    <Form.Field>
                      <label style={styles.label}>Blanco</label>
                      <ListaBLA handleLista={handleLista12} />
                    </Form.Field>
                    <Form.Field>
                      <label style={styles.label}>Ultracentrifuga</label>
                      <input type='number' step="0.00001" min="0" autoComplete="off" name="ultracentrifuga" id="ultracentrifuga" placeholder='Ultracentrifuga' onChange={handleChange}/>
                    </Form.Field>
                    <Form.Field>
                      <label style={styles.label}>Densidad a 15°C</label>
                      <input type='number' step="0.01" min="0" autoComplete="off" name="densidad" id="densidad" placeholder='Densidad a 15°C' onChange={handleChange}/>
                    </Form.Field>
                    <Form.Field>
                      <label style={styles.label}>Punto de fuego</label>
                      <input type='number' step="1" min="0" autoComplete="off" name="fuego" id="fuego" placeholder='Punto de fuego' onChange={handleChange}/>
                    </Form.Field>
                  </div>  
                }  
              </div>    
            </div>
          </div>
          <hr></hr>
            <Button style={styles.confirmar} type='submit' fluid>
              AGREGAR
            </Button>

            {
              errors.length?<Message negative header="Los siguientes errores:"
              list={errors.map(error=>`${error.path}: ${error.message}`)} />:null
            }

        </Form>
      </div>
    </div>
  )
}


export default AddLubricante2
